import React, { useState } from "react";
import { FiDownload } from "react-icons/fi";
import api from "../../services/api";
import { Button } from "./ExportRelatorioCompletoGestantesButton.styles";

export const MSG_SUCESSO = "Relatório completo baixado com sucesso!";
export const MSG_ERRO_GENERICO = "Não foi possível baixar o relatório completo de gestantes.";
export const MSG_SEM_DADOS = "Sem gestantes cadastradas para o seu escopo.";

const NOME_ARQUIVO = "relatorio_completo_gestantes.xlsx";
const MIME_XLSX = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

/** Lê um Blob como texto. Blob.text() não existe em navegadores antigos nem no jsdom. */
const lerBlobComoTexto = (blob) => {
  if (typeof blob.text === "function") return blob.text();
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = () => reject(reader.error);
    reader.readAsText(blob);
  });
};

/**
 * Com responseType "blob" o corpo do erro também vem como Blob, então
 * error.response.data.detail é sempre undefined e a mensagem do backend se perde.
 * É preciso ler o texto do blob e fazer o parse.
 */
const extrairDetalheDoErro = async (error) => {
  const data = error?.response?.data;
  if (!data) return null;
  try {
    const texto = data instanceof Blob ? await lerBlobComoTexto(data) : data;
    const corpo = typeof texto === "string" ? JSON.parse(texto) : texto;
    return corpo?.detail || null;
  } catch {
    return null;
  }
};

const ExportRelatorioCompletoGestantesButton = ({ showSuccess, showError }) => {
  const [isDownloading, setIsDownloading] = useState(false);

  const handleDownload = async () => {
    setIsDownloading(true);
    try {
      const response = await api.get("/relatorios/baixar-relatorio-completo-gestantes", {
        responseType: "blob",
      });

      if (response.data.size === 0) {
        showError?.(MSG_SEM_DADOS);
        return;
      }

      const blob = new Blob([response.data], { type: MIME_XLSX });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", NOME_ARQUIVO);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      showSuccess?.(MSG_SUCESSO);
    } catch (error) {
      console.error("Erro ao baixar o relatório completo de gestantes:", error);
      const detalhe = await extrairDetalheDoErro(error);
      showError?.(detalhe || MSG_ERRO_GENERICO);
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <Button onClick={handleDownload} disabled={isDownloading}>
      {isDownloading ? (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            viewBox="0 0 16 16"
            aria-hidden="true"
          >
            <path d="M8 3a5 5 0 1 0 0 10A5 5 0 0 0 8 3Zm-7 5a7 7 0 1 1 14 0A7 7 0 0 1 1 8Z">
              <animateTransform
                attributeName="transform"
                type="rotate"
                from="0 8 8"
                to="360 8 8"
                dur="1s"
                repeatCount="indefinite"
              />
            </path>
          </svg>
          Baixando...
        </>
      ) : (
        <>
          <FiDownload size={18} />
          Baixar Relatório Completo
        </>
      )}
    </Button>
  );
};

export default ExportRelatorioCompletoGestantesButton;
